export default {
    setCountry(context, country) {
        context.commit('setCountryCode', country);
    }
};
